import { render, staticRenderFns } from "./ActionsLegal.vue?vue&type=template&id=45e31fbe"
import script from "./ActionsLegal.vue?vue&type=script&lang=js"
export * from "./ActionsLegal.vue?vue&type=script&lang=js"
import style0 from "./ActionsLegal.vue?vue&type=style&index=0&id=45e31fbe&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports